import React from 'react';
import { observer } from 'mobx-react';
import { V3Routes } from '../../../routes';
import { SimpleUserView } from '../../../types/users';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { ExamPracticalSectionShowView } from '../../../types/exam_sections';
import { ReviewerAssignmentStatusSummary } from '../lesson_homeworks/ReviewerAssignmentStatusSummary';
import { DetailsButton } from '../../molecules/course_works/DetailsButton';
import './examPracticalSectionHeaderContent.module.scss';

type Props = {
  examPracticalSection: ExamPracticalSectionShowView;
  showReviewer: boolean;
  reviewer?: SimpleUserView | null;
};

export const ExamPracticalSectionHeaderContent = observer(
  ({ examPracticalSection, reviewer = null, showReviewer }: Props) => {
    const { title, description } = examPracticalSection;
    const { isSp } = useViewportState();
    return (
      <div styleName="content" id="exam-practical-section-header">
        <div styleName="day-label">実技試験</div>
        <div styleName="title">{title}</div>
        {description && <pre styleName="description">{description}</pre>}
        <div styleName="bottom-tools">
          {showReviewer && (
            <ReviewerAssignmentStatusSummary id="reviewer-assignment-status-summary" key={1} reviewer={reviewer} />
          )}
          <DetailsButton isSp={isSp} to={V3Routes.examPracticalSection(examPracticalSection.id)} />
        </div>
      </div>
    );
  }
);
